<template>
    <section class="section" v-if="currentOrganizationId">
        <h3 class="title is-3">Редактирование пользователей</h3>

        <b-table
            :data="userList"

            :per-page="options.perPage"
            :current-page.sync="options.currentPage"
            :pagination-simple="false"
            pagination-position="bottom"
            default-sort-direction="asc"
            sort-icon="chevron-up"
            sort-icon-size="is-small"
            :loading="isItemsLoading"

            :backend-filtering="true"
            :backend-sorting="true"
            :backend-pagination="true"
            @filters-change="filterChange"
            @sort="sortChange"
            :total="paginator.total"
            paginated
            striped
            narrowed
            hoverable
            focusable

            :default-sort="options.sortBy"
            :default-sort-direction="options.sortDirection"
            aria-next-label="Следующая страница"
            aria-previous-label="Предыдущая страница"
            aria-page-label="Страница"
            aria-current-label="Текущая страница"
        >

            <b-table-column field="lastName" label="Фамилия"  sortable searchable>
                <template #searchable="props">
                    <b-input
                        v-model="props.filters[props.column.field]"
                        placeholder="Search..."
                        icon="magnify"
                        size="is-small" />
                </template>
                <template v-slot="props">
                    {{ props.row.lastName }}
                </template>
            </b-table-column>
            <b-table-column field="firstName" label="Имя"  sortable searchable>
                <template #searchable="props">
                    <b-input
                        v-model="props.filters[props.column.field]"
                        placeholder="Search..."
                        icon="magnify"
                        size="is-small" />
                </template>
                <template v-slot="props">
                    {{ props.row.firstName }}
                </template>
            </b-table-column>

            <b-table-column field="surName" label="Отчество"  sortable searchable>
                <template #searchable="props">
                    <b-input
                        v-model="props.filters[props.column.field]"
                        placeholder="Search..."
                        icon="magnify"
                        size="is-small" />
                </template>
                <template v-slot="props">
                    {{ props.row.surName }}
                </template>
            </b-table-column>

            <b-table-column field="positionId" label="Должность" searchable sortable>
                <template #searchable="props">
                    <b-select v-model="props.filters[props.column.field]" size="is-small" style="max-width: 200px">
                        <option :value="null">Все</option>
                        <option v-for="position in positionList" :title="position.fullname" :value="position.id">{{position.name}}</option>
                    </b-select>
                </template>
                <template v-slot="props">
                    <span :title="positionNamesByUserRoles(props.row.userRolePivot, currentOrganizationId)">{{ positionNamesByUserRoles(props.row.userRolePivot, currentOrganizationId) }}</span>
                </template>
            </b-table-column>

            <b-table-column field="groupId" label="Группа" searchable sortable>
                <template #searchable="props">
                    <b-select v-model="props.filters[props.column.field]" size="is-small" style="max-width: 200px">
                        <option :value="null">Все</option>
                        <option v-for="group in groupList" :value="group.id">{{group.name}}</option>
                    </b-select>
                </template>
                <template v-slot="props">
                    <span>{{ groupNamesByUserRoles(props.row.userRolePivot, currentOrganizationId) }}</span>
                </template>
            </b-table-column>


            <b-table-column field="action" label="" v-slot="props" width="100px">
                <div class="buttons">
                    <b-button title="Редактировать" @click="selectedUserId = props.row.id" icon-left="pencil" type="is-success" size="is-small"/>
                </div>
            </b-table-column>

            <template #empty>
                <div class="has-text-centered">Нет пользователей</div>
            </template>

            <template #bottom-left>
                <b>Общее количество</b>: {{ paginator.total }}
            </template>
        </b-table>
        <user-modal :user-id.sync="selectedUserId" @saved="userSaved"/>
    </section>
    <section class="section" v-else>Нет доступа</section>
</template>
<script>


import { mapActions, mapGetters } from 'vuex'
import { get, map, cloneDeep, reduce, merge } from 'lodash'
import { NULL_UID } from '../../../constants'
import PaginatedFetchMixin from '../../../mixins/PaginatedFetchMixin'
import UserRolesMixin from '../../../mixins/UserRolesMixin'
import UserModal from './Index/UserModal'

export default {
    components: { UserModal },
    mixins: [
        PaginatedFetchMixin,
        UserRolesMixin,
    ],
    computed: {
        ...mapGetters({
            currentUser: 'e/users/currentUser',
            usersQuery: 'e/users/query',
            groupQuery: 'e/groups/query',
            positionQuery: 'e/positions/query',
            isLoaderActive: 'e/pages/isLoaderActive',
            findGroup: 'e/groups/find',
            findPosition: 'e/positions/find',
            currentOrganizationId: 'e/users/currentOrganizationId',
        }),
        positionList() {
            return this.positionQuery().orderBy('name').where('parentId', value => !!value).findIn(this.positionIds)
        },
        allPositionList() {
            return this.positionQuery().orderBy('name').where('parentId', value => !!value).get()
        },
        groupList() {
            return reduce(
                this.groupQuery().where('cpoId', this.currentOrganizationId).whereHasNot('children').get(),
                (result, item) => {
                    result.push(item)
                    return result
                },
                [{id: NULL_UID, 'name': 'Без группы'}]
            )
        },
        userList () {
            return this.usersQuery().with(['userRolePivot.group', 'userRolePivot.position', 'userRolePivot.organization']).findIn(this.paginator.ids)
        },
        isItemsLoading() {
            return this.isLoaderActive('users.fetchItems')
        },
    },

    methods: {
        ...mapActions({
            fetchItems: 'e/users/fetchItems',
            saveUsers: 'e/users/save',
            fetchGroups: 'e/groups/fetchItems',
            fetchPositions: 'e/positions/fetchItems',
        }),
        filterFieldMap(key, default_ = null) {
            let map = {
                'firstName': 'FirstName',
                'surName': 'SurName',
                'lastName': 'LastName',
                'positionId': 'PositionId',
                'groupId': 'GroupId',
                'roleId': 'RoleId',
                'cpoId': 'cpoId',
            }
            return get(map, key, default_)
        },
        customFilter(filters) {
            let options = cloneDeep(this.options)
            options.sortBy = this.filterFieldMap(options.sortBy, 'createdAt')
            let _filter = {}
            for (let i in this.filters) {
                let key = this.filterFieldMap(i)
                if (key && this.filters[i]) {
                    _filter[key] = this.filters[i]
                }
            }
            return merge({}, options, _filter, filters)
        },

        getPositions() {
            this.fetchPositions({
                CpoId: this.currentOrganizationId
            }).then((data)=>{
                this.positionIds = map(data.data, 'id')
            })
        },

        userSaved() {
            this.getPositions()
        },

        contextChangedHandler() {
            this.fetch()
        },
    },
    data() {
        return {
            selectedUserId: null,
            positionIds: [],
        }
    },
    watch: {
        currentOrganizationId: {
            immediate: true,
            handler (organizationId) {
                if (organizationId) {
                    this.fetch()
                    this.fetchGroups({ CpoId: organizationId })
                    this.getPositions()
                }
            }
        },
    }
}
</script>